import { makeApi } from "./callApi.jsx";
import { LocalStorageUtils } from "../utils/localstorage.utils.jsx";


import { getDeviceId, getDeviceType, getDeviceDetails, getNotificationToken, getLocation } from "../utils/helper.jsx";
import AnalyticsService from "services/analytics.service.js";

export class CustomerApi {
  static async login({ mobile, otpToken }) {
    const loginData = {
      mobile,
      otpToken,
      deviceType: getDeviceType(),
      deviceId: getDeviceId(),
      deviceDetails: getDeviceDetails(),
      notificationToken: getNotificationToken(),
      locationDetails: getLocation(),
    };
    console.log("loginData", loginData);
    const response = await makeApi(`/customer/login`, "POST", loginData);
    const loginResponse = response.data;
    LocalStorageUtils.set(
      LocalStorageUtils.LOCAL_STORAGE_KEY.AUTH_TOKEN,
      loginResponse.token
    );
    LocalStorageUtils.set(
      LocalStorageUtils.LOCAL_STORAGE_KEY.USER,
      loginResponse.user
    );
    AnalyticsService.identifyUser();
    console.log("CustomerApi.login", loginResponse);
    return loginResponse;
  }

  static async createAddress(addressData) {
    const response = await makeApi(
      `/customer/address/create`,
      "POST",
      addressData
    );
    return response.data;
  }

  static async updateAddress(addressId, addressData) {
    const response = await makeApi(`/customer/address/${addressId}`, "PATCH", addressData);
    return response.data;
  }

  static async getAddressList() {
    const response = await makeApi(`/customer/address/list`, "GET");
    return response.data;
  }

  static async deleteAddress(addressId) {
    const response = await makeApi(`/customer/address/${addressId}`, "DELETE");
    return response.data;
  }
}
